import { differenceInMilliseconds, hoursToMilliseconds, parseISO } from "date-fns";

export function isShiftShortLeadTime(shiftStart: string, shortLeadTimeOffsetInHours: number) {
  const now = new Date();
  const shiftStartDate = parseISO(shiftStart);

  const diffMs = differenceInMilliseconds(shiftStartDate, now);
  return diffMs < hoursToMilliseconds(shortLeadTimeOffsetInHours);
}
